import { atom } from "jotai";
import {
  emitEventOnStartingOverAtom,
  zslExecutionFailedErrorMsgAtom,
  showAIStreamCreateModalAtom,
  togglesAtom,
  isAiPageAtom,
  createNewCanvasAtom,
} from "@zapier/canvas-state";

import { aiPromptAtomResettable } from "./aiPromptAtom";
import { showWelcomeModalAtom } from "./showWelcomeModalAtom";
import { outlineAtom } from "./outlineAtom";
import { startOverConfirmationAtom } from "./startOverConfirmationAtom";

// The actual start over implementation - extracted to a separate atom for reuse
const executeStartOver = atom(null, async (get, set) => {
  const isAiPage = get(isAiPageAtom);

  if (isAiPage) {
    await set(emitEventOnStartingOverAtom);
    // We need to wait for the event to be emitted before we can create a new canvas
    // Otherwise, the canvas will be created before the event is emitted and the event will be lost
    setTimeout(() => {
      set(createNewCanvasAtom, {
        nodes: [],
        edges: [],
      });
    }, 0);

    return;
  }

  set(showAIStreamCreateModalAtom, false);
  set(showWelcomeModalAtom, true);
  set(aiPromptAtomResettable, "");

  const toggles = get(togglesAtom);
  if (!toggles.streamingUi) {
    set(outlineAtom, "");
  }
  set(zslExecutionFailedErrorMsgAtom, null); // Clear out old error alert
  await set(emitEventOnStartingOverAtom);
});

export const startOverCommand = atom(null, async (get, set) => {
  set(startOverConfirmationAtom, {
    isOpen: true,
    message: "Do you wish to continue?",
    onConfirm: () => {
      set(executeStartOver);
    },
  });
});

startOverCommand.debugLabel = "startOverCommand";
executeStartOver.debugLabel = "executeStartOver";
